import { render, staticRenderFns } from "./NhlTopPlaysTable.vue?vue&type=template&id=56d8321e&scoped=true"
import script from "./NhlTopPlaysTable.vue?vue&type=script&lang=js"
export * from "./NhlTopPlaysTable.vue?vue&type=script&lang=js"
import style0 from "./NhlTopPlaysTable.vue?vue&type=style&index=0&id=56d8321e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8321e",
  null
  
)

export default component.exports